export default __webpack_public_path__ + "static/media/images.090840d3.svg";